import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Job from "../components/Job";

export default function JobsList() {
  const { jobs, loading, error } = useSelector((state) => state.jobs);
  const { type, sort, search } = useSelector((state) => state.jobsFilter);

  // jobs that matched with the type
  const typeMatchedJobs = jobs.filter((job) => {
    return job.type.toLowerCase().includes(type.toLowerCase());
  });
  // jobs that matched with the searched text from the typeMatched jobs
  const searchedJobs = typeMatchedJobs.filter((job) => {
    return job.title.toLowerCase().includes(search.toLowerCase());
  });
  // final jobs to show after sorting
  const sortedJobs = searchedJobs.sort((a, b) => {
    const salaryA = parseInt(a.salary.replace(",", ""));
    const salaryB = parseInt(b.salary.replace(",", ""));
    if (sort === "Salary (Low to High)") return salaryA - salaryB;
    else if (sort === "Salary (High to Low)") return salaryB - salaryA;
    else {
      return false;
    }
  });
  useEffect(() => {}, [search, sort, type, jobs]);

  return (
    <div className="jobs-list ">
      {/* showed loading when loading */}
      {loading && <p className="loading">Loading...</p>}

      {/* showed error text if there is any error  */}
      {!loading && error && <p className="loading">{error}</p>}

      {/* showed below text if there is no jobs exist based on type or search */}
      {!loading && !error && sortedJobs.length === 0 && (
        <p className="loading text-center">
          No available jobs found for {type ? type : search}!
        </p>
      )}

      {/* showed the jobs if no error and not loading  */}
      {!loading &&
        !error &&
        sortedJobs.map((job) => <Job key={job.id} job={job} />)}
    </div>
  );
}
